angular.module('picmonic-common').factory('PromoCodesResource', [
  '$resource',
  function ($resource) {
    return $resource(
      '/api/v3/promo_codes',
      {},
      {
        check_expiration: {
          method: 'Post',
          url: '/api/v3/promo_codes/check_expiration',
          isArray: false,
        },
        validate: {
          method: 'Post',
          url: '/api/v3/promo_codes/validate',
          isArray: false,
        },
      }
    );
  },
]);
